
// const state = {
//   cards: [],
// };


// const mutations = {
//   setCardData(state, cardData) {
//         state.cards =cardData;
//       }
// };
// export default {
//   state,
//   mutations,
// };



import axios from "axios";
import router from "../../router";

const token = window.localStorage.getItem("token");
const state = {
  cards: [],
  limits: {}
  // card:[],
  // users:[],
};
const getters = {
  allCards: state => state.cards,
  // allUsers: state => state.users

};
const actions = {
  async fetchCard({ commit }) {
    let response = await axios.get('cards')
    commit('setCardData', response.data.data)
  },
  async createCard({ commit }){
    axios.get('card/create-default')
    .then((response) => {
      commit("DEFAULT_CARD", response.data);
      router.push("/");
    })
    .catch((e) =>{  
      console.log(e);
    });
  },
  async PrivateCard({ commit }, data){
    axios.post("card/private",data)
    .then((response) => {
      commit("PRIVATE_CARD", response.data);
    })
    .catch((e) =>{
      console.log(e);
    });
  },
  async cardUpdate({ commit }, data){
    axios.post("card/update",data)
    .then((response) => {
      commit("CARD_UPDATE", response.data);
      router.push("/");

    })
    .catch((e) =>{
      console.log(e);
    });
  },
  async createNewCard({ commit }, data){
    axios.post("card/create",data)
    .then((response) => {
      commit("CARD_NEW_CREATE", response.data);
      router.push("/");

    })
    .catch((e) =>{
      console.log(e);
    });
  }
};
const mutations = {
  setUserData(state, userData) {
    state.users =userData;
  },
  setCardData(state, cardData) {
    // state.card.push(cardData);
    state.cards = cardData;
  },
  setLimitData(state, planLimits) {
    // Plan limits for contacts and social media.
    console.log("Limits set: ", JSON.stringify(planLimits));
    state.limits = planLimits;
  },
  SAVE_CARDS(state, cards) {
    state.cards = cards;
  },
  DEFAULT_CARD(state, cards){
    state.cards = cards;
  },
  PRIVATE_CARD(state, cards){
    state.cards = cards;
  },
  CARD_UPDATE(state, cards){
    state.cards = cards;
  },
  CARD_NEW_CREATE(state, cards){
    state.cards = cards;
  },
  setCardOrganizationDetails(state, organization_details) {
    console.log("state.cards from store");
    console.log(state.cards);
    state.cards.organization_details = organization_details;
  },
  setCardAddToSocialMediaList(state, newSocialMedia) {
    console.log("Updating social_media_list state.cards from store");
    console.log(state.cards.social_media_list);
    state.cards.social_media_list.push(newSocialMedia);
  },

};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
